import React from 'react';

export type BgisMapAreaProps = {
  showToolbar?:boolean,
  showLegend?:boolean,
  children?: React.ReactNode;
};

export const BgisMapArea : React.FC<BgisMapAreaProps> = ({showToolbar, showLegend, children }: BgisMapAreaProps) => {
  return (
      <div className={'bgis-map-area' + ((showToolbar && showToolbar===true ) ? ' show-toolbar' :'') + ((showLegend && showLegend===true ) ? ' show-legend' :'')}>{children}</div>
  );
};
